import styled from 'styled-components';
import { Divider, Flex } from 'UI';
import { useBreakpointSelectorFull } from 'utils';

export const Container = styled.div`
  text-align: left;
  margin: 10px 35px 10px 35px;
  min-height: calc(
    100vh - 20px -
      ${() => useBreakpointSelectorFull()({ xs: 100, sm: 50, md: 50, lg: 50, xl: 50, xml: 50, xxl: 100 }) + 'px'} - 48px -
      90px
  );
  width: 100%;
  max-width: 1320px;
  padding: 0 15px;
`;

export const SectionWrapper = styled.div<{
  borderless?: boolean;
}>`
  width: 100%;
  min-width: 150px;
  ${({ borderless, theme }) =>
    borderless
      ? `
    padding-bottom: 16px;
  `
      : `
    border: 2px dashed ${theme.color.grey85};
    border-radius: 20px;
    padding: 16px;
  `}
`;

export const ItemWrapper = styled.div<{
  isViewStyle?: boolean;
}>`
  border-radius: 20px;
  ${({ isViewStyle, theme }) =>
    isViewStyle
      ? `
    padding: 16px;
    background-color: ${theme.color.grey95};
  `
      : `
    margin-top: 15px;
  `};
`;

export const ItemContentWrapper = styled.div<{
  maxWidth?: number;
}>`
  width: 100%;
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth}px;`}
`;

export const SectionItemsWrapper = styled(Flex)<{
  isViewStyle?: boolean;
}>`
  border-radius: 20px;
  ${({ isViewStyle, theme }) =>
    isViewStyle &&
    `
    padding: 1px 16px;
    background-color: ${theme.color.grey95};
  `}
`;

export const SDivider = styled(Divider)`
  margin: 0px -16px !important;
  width: auto;
  ${({ theme }) => `
    border-color: ${theme.color.grey95};
  `};
`;

export const BrandCheckBox = styled.div<{ $isSelected?: boolean }>`
  width: 160px;
  height: 95px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  box-shadow: 0 0 10px 0 ${({ theme }) => theme.color.shadow_2};
  ${({ theme, $isSelected }) => $isSelected && `border: solid 4px ${theme.color.info_dark};`};
  cursor: pointer;

  :hover {
    transform: scale(1.05);
  }
`;
